import { HoldStateMapper } from '../hold/HoldState.mapper';
import { Promotion, PromotionHold } from "webshop-api";
import { PromotionHoldState } from "@/domain/ticket-selection";

export class PromotionHoldStateMapper {

    /**
     * whatItDoes
     * maps PromotionHold entity to PromotionHoldState
     */
    public static fromPromotionHold(
        object: PromotionHold,
        applicationTicketMaximum: number,
        promotionList: Promotion[]
    ): PromotionHoldState {
        return {
            active: object.id === 0,
            id: object.id!,
            holds: object.holds
                ? object.holds.map(entity => HoldStateMapper.fromHold(
                    entity,
                    applicationTicketMaximum,
                    promotionList.find(promotion => promotion.id === object.id)
                ))
                : [],
        };
    }

}
